import React from 'react';
import { Linkedin, Instagram, Youtube } from 'lucide-react';
import Reveal from './Reveal';
import { FOUNDERS, FOUNDERS_TOGETHER } from '../mock';

export default function About() {
  return (
    <section id="about" className="bg-[var(--ob-bg)] py-24 md:py-32">
      <div className="mx-auto grid max-w-[1280px] grid-cols-1 items-center gap-12 px-5 md:px-8 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
        {/* Primary visual: Jake & Luke together */}
        <Reveal>
          <figure className="relative overflow-hidden rounded-[1.75rem] border border-[var(--ob-line)] bg-[var(--ob-bg-alt)]">
            <div className="aspect-[4/5] w-full">
              <img
                src={FOUNDERS_TOGETHER}
                alt="Jake and Luke, founders of OnBrand Emails"
                loading="lazy"
                className="h-full w-full object-cover object-top"
              />
            </div>
            <figcaption className="absolute inset-x-0 bottom-0 flex items-end justify-between bg-gradient-to-t from-black/70 to-transparent p-6">
              <div>
                <div className="font-display text-lg font-bold text-white">Jake &amp; Luke</div>
                <div className="text-sm text-white/70">Founders of OnBrand</div>
              </div>
            </figcaption>
          </figure>
        </Reveal>

        {/* Text + individual portraits */}
        <Reveal delay={100}>
          <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-[var(--ob-accent-dark)]">
            About Us
          </p>
          <h2 className="font-display text-4xl font-extrabold tracking-tight text-[var(--ob-ink)] md:text-5xl">
            Real people. Real retention systems.
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-[var(--ob-ink-soft)]">
            <p>
              OnBrand is run by <span className="font-semibold text-[var(--ob-ink)]">Jake and Luke</span>, a
              hands-on team with over 10 years of combined experience scaling retention for Shopify brands.
            </p>
            <p>
              We deconstruct and rebuild email &amp; SMS systems for 8- to 9-figure brands, applying a
              high-performance mindset to help founders grow faster, increase profitability and reach the
              next level.
            </p>
          </div>

          {/* Secondary visuals: individual founders */}
          <div className="mt-9 grid grid-cols-2 gap-4">
            {FOUNDERS.map((f) => (
              <div
                key={f.name}
                className="ob-email-card overflow-hidden rounded-2xl border border-[var(--ob-line)] bg-white"
              >
                <div className="aspect-square w-full overflow-hidden">
                  <img
                    src={f.photo}
                    alt={`${f.name}, ${f.role} of OnBrand`}
                    loading="lazy"
                    className="h-full w-full object-cover object-center"
                  />
                </div>
                <div className="flex items-center justify-between px-4 py-3">
                  <div>
                    <div className="font-display text-base font-bold text-[var(--ob-ink)]">{f.name}</div>
                    <div className="text-xs text-[var(--ob-ink-soft)]">{f.role}</div>
                  </div>
                  <div className="flex gap-2 text-[var(--ob-ink-soft)]">
                    <a href={f.socials.linkedin} target="_blank" rel="noopener noreferrer" aria-label={`${f.name}'s LinkedIn`} className="hover:text-[var(--ob-accent-dark)]"><Linkedin size={16} /></a>
                    <a href={f.socials.instagram} target="_blank" rel="noopener noreferrer" aria-label={`${f.name}'s Instagram`} className="hover:text-[var(--ob-accent-dark)]"><Instagram size={16} /></a>
                    <a href={f.socials.youtube} target="_blank" rel="noopener noreferrer" aria-label={`${f.name}'s YouTube`} className="hover:text-[var(--ob-accent-dark)]"><Youtube size={16} /></a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
